import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRegulationOptionsQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string, name: string }> };


export const GetRegulationOptionsDocument = gql`
    query GetRegulationOptions {
  regulations {
    id
    regulationNumber
    name
  }
}
    `;

/**
 * __useGetRegulationOptionsQuery__
 *
 * To run a query within a React component, call `useGetRegulationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegulationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegulationOptionsQuery, GetRegulationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationOptionsQuery, GetRegulationOptionsQueryVariables>(GetRegulationOptionsDocument, options);
      }
export function useGetRegulationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationOptionsQuery, GetRegulationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationOptionsQuery, GetRegulationOptionsQueryVariables>(GetRegulationOptionsDocument, options);
        }
export type GetRegulationOptionsQueryHookResult = ReturnType<typeof useGetRegulationOptionsQuery>;
export type GetRegulationOptionsLazyQueryHookResult = ReturnType<typeof useGetRegulationOptionsLazyQuery>;
export type GetRegulationOptionsQueryResult = Apollo.QueryResult<GetRegulationOptionsQuery, GetRegulationOptionsQueryVariables>;